var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',{staticClass:"mfo-rules__block-title"},[_vm._v("Правила предоставления микрокредитов")]),_c('div',{staticClass:"mfo-rules",domProps:{"innerHTML":_vm._s(_vm.document)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }